import React from 'react';
import PropTypes from 'prop-types';
import styles from './Collage.module.scss';
import Image from '../../components/Image';
import isEmpty from '../../utils/isEmpty';
import Wysiwyg from '../Wysiwyg';
import classNames from 'classnames';

const Collage = ({ images, text }) => {
    const collageClass = classNames(styles['Collage'], {
        [styles['Collage--HasText']]: !isEmpty(text),
    });
    return (
        !isEmpty(images) && (
            <div className={collageClass}>
                {images.map(({ image }, idx) => (
                    <Item image={image} key={idx} />
                ))}
                {text && <Item text={text} />}
            </div>
        )
    );
};

const Item = ({ image, text }) => (
    <div className={styles['Collage__Item']}>
        {image && (
            <div className={styles['Collage__Image']}>
                <Image {...image} />
            </div>
        )}
        {text && (
            <div className={styles['Collage__Content']}>
                <Wysiwyg html={text} />
            </div>
        )}
    </div>
);

Collage.propTypes = {
    images: PropTypes.array,
    text: PropTypes.string,
};

Collage.defaultProps = {
    images: [],
    text: '',
};

export default Collage;
